module.exports = __webpack_public_path__ + "2cf49f3fa4176f2e699d7fd56f57730a.MP3";